import React, {useEffect} from "react";
import {bindActionCreators} from "redux";
import {useDispatch, useSelector} from "react-redux";
import commonActions from "../../../Actions/commonActions";

const VerticalNavigation = ({children}) => {
    const dispatch = useDispatch();
    const sideMenuOpen = useSelector((state) => state.CommonReducer.sideMenuOpen);
    const actions = bindActionCreators(commonActions, dispatch);

    let timeOutFunctionId;

    useEffect(() => {
        const handleResize = () => {
            clearTimeout(timeOutFunctionId);
            timeOutFunctionId = setTimeout(() => {
                const innerWidth = window.innerWidth

                if (innerWidth <= 992) hideMenu()
                if (innerWidth > 992) showMenu();
            }, 200);
        }

        handleResize();
        window.addEventListener('resize', handleResize)
    }, [])

    const hideMenu = () => {
        actions.toggleSideMenu(false);
    }

    const showMenu = () => {
        actions.toggleSideMenu(true);
    }

    const showHideMenu = () => {
        // without parameter it will toggle
        actions.toggleSideMenu();
    }

    return (
        <div className={`vertical-nav${!sideMenuOpen? ' hidden-menu' : ''}`}>
            <ul className="nav" aria-expanded={!sideMenuOpen}>
                {children}
            </ul>
            <li className="show-nav">
                <a onClick={showHideMenu} aria-controls="verticalNav" aria-expanded={!sideMenuOpen}>
                    Show/Hide Menu
                </a>
            </li>
        </div>
    );
}

export default VerticalNavigation;